import { computed, type ComputedRef } from 'vue'
import { useAuthStore } from '@/modules/auth'

const CORE_MODULES = ['dashboard', 'users', 'roles', 'catalogs'] as const

export function useEnabledModules() {
  const auth = useAuthStore()

  const enabledModules: ComputedRef<string[]> = computed(
    () => auth.user?.tenant?.enabled_modules ?? [],
  )

  const isModuleEnabled = (slug: string): boolean => {
    if ((CORE_MODULES as readonly string[]).includes(slug)) {
      return true
    }

    return enabledModules.value.includes(slug)
  }

  return {
    enabledModules,
    isModuleEnabled,
  }
}
